import { render, staticRenderFns } from "./TableSetSettingsFields.vue?vue&type=template&id=39188cae&scoped=true&"
import script from "./TableSetSettingsFields.vue?vue&type=script&lang=ts&"
export * from "./TableSetSettingsFields.vue?vue&type=script&lang=ts&"
import style0 from "./TableSetSettingsFields.vue?vue&type=style&index=0&id=39188cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39188cae",
  null
  
)

export default component.exports